"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = exports.isBoolean = exports.isNumber = exports.isString = exports.isFalsy = exports.noExist = exports.nonEmpty = exports.isTruthy = exports.isExist = exports.isEmpty = void 0;
/**
 * return true when match following condition
 *  1. is undefined or null
 *  2. is empty string
 *  3. is empty object ({})
 *  4. is empty array ([])
 *
 * @param t input on any data type
 */
exports.isEmpty = function (t) {
    if (exports.noExist(t))
        return true;
    if (exports.isObject(t) && exports.isEmpty(Object.keys(t)))
        return true;
    else if (Array.isArray(t) && t.length <= 0)
        return true;
    else if (typeof t === "string" && t === "")
        return true;
    return false;
};
exports.isExist = function (t) {
    return t !== undefined && t !== null;
};
exports.isTruthy = function (t) {
    if (t)
        return true;
    else
        return false;
};
/**
 * The reverse function of isEmpty
 *
 * @param t input on any data type
 */
exports.nonEmpty = function (t) {
    return !exports.isEmpty(t);
};
exports.noExist = function (t) {
    return t === undefined || t === null;
};
exports.isFalsy = function (t) {
    if (t)
        return false;
    else
        return true;
};
exports.isString = function (t) {
    return exports.isExist(t) && typeof t === "string";
};
exports.isNumber = function (t, ignoreSpecial) {
    if (ignoreSpecial === void 0) { ignoreSpecial = false; }
    if (exports.isExist(t)) {
        if (typeof t === "number") {
            if (ignoreSpecial)
                return true;
            else
                return !isNaN(t) && isFinite(t);
        }
    }
    return false;
};
exports.isBoolean = function (t) {
    return exports.isExist(t) && typeof t === "boolean";
};
/**
 * checking is input is object datatype (object mean typeof input will return object)
 *
 * @param obj input of any type
 */
exports.isObject = function (obj) {
    if (obj === undefined || obj === null)
        return false;
    else
        return typeof obj === "object" && !Array.isArray(obj);
};
//# sourceMappingURL=generic.js.map